const Search = () => {
    return (
        <div>
            <div class="input-group pt-5">
                <input type="search" class="form-control rounded" placeholder="" aria-label="Search" aria-describedby="search-addon" />
                <button type="button" class="btn btn-outline-warning">Чустучу</button>
            </div>

        </div>
    )
}

export default Search; 